import type { EpcScheduleTaskRow } from '../../types/scheduleTask';

/** Rows whose draft differs from the original (same index — inline edit has no structural ops). */
export function countChangedRows(
  original: EpcScheduleTaskRow[],
  draft: EpcScheduleTaskRow[]
): number {
  let n = 0;
  const len = Math.max(original.length, draft.length);
  for (let i = 0; i < len; i += 1) {
    const a = original[i];
    const b = draft[i];
    if (!a || !b) {
      n += 1;
      continue;
    }
    if (JSON.stringify(a) !== JSON.stringify(b)) n += 1;
  }
  return n;
}
